import React, { Suspense } from 'react'
import { GetHelpLayout } from '../../layouts/GetHelpLayout'
import GetHelpDecisionWizard from './GetHelpDecisionWizard'
import './GetHelp.css'

const GetHelpLanding = () => {
  return (
    <Suspense fallback={null}>
      <GetHelpLayout>
        <GetHelpDecisionWizard />
      </GetHelpLayout>
    </Suspense>
  )
}

export default GetHelpLanding
